import { api } from "@shared/api/client";
import type {
  CopyField,
  InfraResponse,
  MantenimientoInfraestructuraPayload,
} from "../types/mantenimiento-infraestructuras";

const endpoint = "/certificaciones/iso-9001-14001/mantenimiento-infraestructuras";

export async function getInfra(
  params: Record<string, string | number | undefined>,
  signal?: AbortSignal,
) {
  const { data } = await api.get<InfraResponse>(endpoint, { params, signal });
  return data;
}

export async function saveInfra(
  id: number | null,
  payload: MantenimientoInfraestructuraPayload,
) {
  if (id) {
    await api.put(`${endpoint}/${id}`, payload);
  } else {
    await api.post(endpoint, payload);
  }
}

export async function deleteInfra(id: number) {
  await api.delete(`${endpoint}/${id}`);
}

export async function createInfraYear(
  sourceYear: number,
  targetYear: number,
  copyFields: CopyField[],
) {
  await api.post(`${endpoint}/crear-plantilla-anual`, {
    source_year: sourceYear,
    target_year: targetYear,
    copy_fields: copyFields,
  });
}

export async function deleteInfraYear(year: number) {
  await api.delete(`${endpoint}/anios/${year}`);
}

export const infraControlEndpoint = `${endpoint}/control-modificaciones`;
